import * as React from 'react';
import { clsx } from 'clsx';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import { useTagOnKeyDown } from '../../hooks';
import styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Tag = props => {
  const {
    children,
    onClose,
    onClick,
    icon,
    disabled = false,
    colorType = 'default',
    setTagWidth,
    id,
    dataTestId,
    maxWidth
  } = props;
  const tagRef = React.useRef(null);
  const handleClose = React.useCallback(e => {
    e.stopPropagation();
    onClose();
  }, [onClose]);
  const onKeyDown = useTagOnKeyDown(onClose);
  useIsomorphicLayoutEffect(() => {
    if (tagRef.current) {
      if (maxWidth) {
        tagRef.current.style.maxWidth = "".concat(maxWidth, "px");
        setTagWidth(id, maxWidth);
      } else {
        setTagWidth(id, tagRef.current.clientWidth);
      }
    }
  }, [id, maxWidth, setTagWidth]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['tag_wrapper'],
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsxs("button", {
      className: clsx(styles['tag'], styles[colorType], onClick && styles['interactive'], disabled && styles['disabled']),
      onKeyDown: onKeyDown,
      onClick: onClick,
      disabled: disabled,
      ref: tagRef,
      "data-testid": "".concat(dataTestId, "-tag"),
      tabIndex: onClick ? 0 : -1,
      children: [icon && /*#__PURE__*/_jsx("div", {
        className: styles['tag_icon'],
        children: icon
      }), /*#__PURE__*/_jsx("div", {
        className: styles['tag_content'],
        children: children
      })]
    }), /*#__PURE__*/_jsx("button", {
      className: clsx(styles['tag_close'], styles[colorType], disabled && styles['disabled']),
      disabled: disabled,
      onClick: handleClose,
      "data-testid": "".concat(dataTestId, "-close"),
      children: /*#__PURE__*/_jsx(IconActionClose12, {
        color: "current_color"
      })
    })]
  });
};
Tag.displayName = 'Tag';